import { render } from "./CharacteristicColorsView.vue?vue&type=template&id=04c0a496&scoped=true&ts=true"
import script from "./CharacteristicColorsView.vue?vue&type=script&lang=ts"
export * from "./CharacteristicColorsView.vue?vue&type=script&lang=ts"

import "./CharacteristicColorsView.vue?vue&type=style&index=0&id=04c0a496&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c0a496"]])

export default __exports__